import { render, staticRenderFns } from "./ProjectConfigurationPrivacy.vue?vue&type=template&id=633d14bf&scoped=true&"
import script from "./ProjectConfigurationPrivacy.vue?vue&type=script&lang=js&"
export * from "./ProjectConfigurationPrivacy.vue?vue&type=script&lang=js&"
import style0 from "./ProjectConfigurationPrivacy.vue?vue&type=style&index=0&id=633d14bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633d14bf",
  null
  
)

export default component.exports